import Navbar from "../components/navbar"
import { useState } from "react"
import { FaBars } from "react-icons/fa"
import { AiOutlineStar, AiFillPhone } from "react-icons/ai"
import { HiMail } from "react-icons/hi"
import { ImPower } from "react-icons/im"
import { FiUsers } from "react-icons/fi"
import { BiPlusMedical } from "react-icons/bi"
import { MdOutlineCardTravel } from "react-icons/md"
import { CiStethoscope } from "react-icons/ci"
import { AiOutlineClockCircle } from "react-icons/ai"
import { BsCalendar2Check, BsFillShareFill } from "react-icons/bs"
import { FaThumbsUp } from "react-icons/fa"
import { BsBoxArrowUpRight } from "react-icons/bs"

import Footer from "../components/footer"

const JobDetailsPage = () => {
    const [navShown, setNavShown] = useState("hidden")
    const [showBar, setShowBar] = useState(true)
    const [showXmark, setShowXmark] = useState("hidden")
    const openNav = () => {
        setNavShown("block")
        setShowBar("hidden")
        setShowXmark("inline")
    }
    const closeNav = () => {
        setNavShown("hidden")
        setShowBar("inline")
        setShowXmark("hidden")
    }
    return (
        <Navbar active={"jobs"} navShow={navShown}>
            <div className="flex w-full bg-cyan-900 items-center fixed z-20">
                <FaBars className={`text-[20px] text-white relative left-4 lg:hidden ${showBar}`} onClick={openNav} />
                <span className={`text-[25px] ${showXmark} text-white font-bold relative left-72`} onClick={closeNav}>
                    X
                </span>
                <h1 className="text-center text-white py-4 w-full font-bold">Job details</h1>
            </div>
            <div className="relative top-14">
                <div className="px-4 mt-5">
                    <div className="flex gap-x-2 pb-8 flex-col lg:flex-row">
                        <div className="lg:w-[60%]">
                            <div className="p-4 rounded-lg" style={{
                                boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                            }}
                            >
                                <h1 className="font-medium pb-2">Job Details</h1>

                                <div className="flex flex-col justify-center sm:justify-normal sm:flex-row gap-x-3 border-b border-gray-400 pb-8">
                                    <div className="my-2 md:m-0">
                                        <img src="https://cdn.ayahealthcare.com/marketingpublic/seattle_wa--200x200.png" alt="" />
                                    </div>
                                    <div>
                                        <div className="flex gap-x-1">
                                            <button className="bg-cyan-100 rounded text-xs px-2 py-1">
                                                New
                                            </button>
                                            <div className="flex items-center gap-x-1 bg-cyan-100 w-fit px-2 py-1 rounded">
                                                <AiOutlineStar className="text-gray-600 text-lg" />
                                                <p className="text-xs">Aya advantage</p>
                                            </div>
                                        </div>
                                        <div className="flex gap-x-1 items-center mt-2 text-gray-600">
                                            <span className="h-5 w-5 flex justify-center rounded-full items-center bg-red-600">
                                                <ImPower className="text-white text-sm" />
                                            </span>
                                            <span className="text-red-600 font-medium">Crisis response
                                            </span>
                                        </div>
                                        <div className="text-xs flex flex-col gap-y-4 mt-2 text-gray-600">
                                            <span className="block font-bold uppercase text-[18px]">
                                                Seattle, Wa
                                            </span>
                                            <div className="flex items-center gap-x-1">
                                                <BiPlusMedical className="text-lg" />
                                                <span className="block font-semibold">
                                                    Harborview Medical Center
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <MdOutlineCardTravel className="text-lg" />
                                                <span className="block">
                                                    Travel
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <CiStethoscope className="text-lg" />
                                                <span className="block">
                                                    ICU
                                                </span>
                                            </div>

                                            <div className="flex items-center gap-x-1">
                                                <AiOutlineClockCircle className="text-lg" />
                                                <span className="block">
                                                    4x12 Night
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <span className="text-lg font-semibold">
                                                    $
                                                </span>
                                                <span className="block">
                                                    $3476.59 to $3640.39 weekly
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <FiUsers className="text-lg" />
                                                <span className="block">
                                                    6 Openings
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <BsCalendar2Check className="text-lg" />
                                                <span className="block">
                                                    6/26/2023*
                                                </span>
                                            </div>
                                            <div className="flex items-center gap-x-1">
                                                <span>
                                                    Job ID
                                                </span>
                                                <span className="block">
                                                    2117052
                                                </span>
                                            </div>

                                            <p className="font-normal">
                                                *This info is approximate. Please confirm with your recruiter.
                                            </p>

                                            <div className="flex items-center gap-x-1 font-semibold">
                                                <BsFillShareFill />
                                                Share
                                            </div>

                                            <div>
                                                <button className="flex items-center gap-x-2">
                                                    <FaThumbsUp className="text-[16px]" />
                                                    <span className="uppercase font-medium">
                                                        Interested 6/17/23
                                                    </span>
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                                <div className="border-b pb-6 border-gray-400 mt-2">
                                    <h1 className="font-semibold text-lg">
                                        Qualifications
                                    </h1>
                                    <div className="mt-2">
                                        <h2 className="font-semibold">
                                            Experience
                                        </h2>
                                        <ul className="list-disc list-inside px-2 text-sm">
                                            <li>MUST have 1.0 YEAR(S) experience</li>
                                            <li>Unit beds: 23</li>
                                            <li>Days: 4, Nights: 4</li>
                                        </ul>
                                    </div>
                                    <div className="mt-2">
                                        <h2 className="font-semibold">
                                            Requirements
                                        </h2>
                                        <ul className="list-disc list-inside px-2 text-sm">
                                            <li>Certifications: BCLS</li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="py-6">
                                    <h1 className="font-bold">About the Facility</h1>
                                    <div className="flex gap-x-2 mt-2">
                                        <button className="bg-gray-600 py-1 px-2 text-xs text-white rounded">
                                            Trauma - I
                                        </button>
                                        <button className="bg-gray-600 py-1 px-2 text-xs text-white rounded">
                                            Trauma - I
                                        </button>
                                        <button className="bg-gray-600 py-1 px-2 text-xs text-white rounded">
                                            Trauma - I
                                        </button>
                                        <button className="bg-gray-600 py-1 px-2 text-xs text-white rounded">
                                            Trauma - I
                                        </button>
                                    </div>
                                    <div className="flex flex-col text-sm mt-2">
                                        <div className="flex gap-x-2">
                                            <span className="font-semibold">Charting System</span>
                                            <span>
                                                Epic
                                            </span>
                                        </div>
                                        <div className="flex gap-x-2">
                                            <span className="font-semibold">Facility Beds</span>
                                            <span>
                                                332 beds
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-2 mt-2">
                                            <a href="#" className="font-medium underline text-cyan-800">
                                                Learn more about this facility
                                            </a>
                                            <BsBoxArrowUpRight className="text-cyan-800 font-medium" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="p-4 rounded-lg mt-4" style={{
                                boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                            }}
                            >
                                <h1 className="font-medium pb-3">Travel Happy with Aya Healthcare</h1>
                                <div>
                                    <h2 className="font-semibold">Aya delivers:</h2>
                                    <ul className="px-2 list-disc list-inside text-sm">
                                        <li><span className="font-semibold">The most jobs in the industry.</span>We have the largest and most reliable job database, which means the jobs you see are open, updated in real time and ready for you!</li>
                                        <li><span className="font-semibold">The most jobs in the industry.</span>We have the largest and most reliable job database, which means the jobs you see are open, updated in real time and ready for you!</li>
                                        <li><span className="font-semibold">The most jobs in the industry.</span>We have the largest and most reliable job database, which means the jobs you see are open, updated in real time and ready for you!</li>
                                        <li><span className="font-semibold">The most jobs in the industry.</span>We have the largest and most reliable job database, which means the jobs you see are open, updated in real time and ready for you!</li>
                                    </ul>
                                </div>
                                <div className="mt-3">
                                    <h2 className="font-semibold py-2">Plus, you get everything you expect from the largest healthcare staffing company in the industry:</h2>
                                    <ul className="px-2 list-disc list-inside text-sm">
                                        <li>Exceptional benefits, including premium medical, dental, vision and life insurance beginning day one of your assignment. Want to take time off? Keep insurance coverage for up to 24 days between assignments.</li>
                                        <li>A generous 401(k) match.</li>
                                        <li>Paid company housing (we’ll help you bring your pets along, too!) or a generous housing stipend.</li>
                                        <li>Paid sick time in accordance with all applicable state, federal, and local laws. Aya's general sick leave policy is that employees accrue one hour of paid sick leave for every 30 hours worked. However, to the extent any provisions of the statement above conflict with any applicable paid sick leave laws, the applicable paid sick leave laws are controlling.</li>
                                        <li>The industry’s only clinical ladder program for RNs on assignment.</li>
                                        <li>Access to unlimited continuing education units online.</li>
                                        <li>Licensure, relocation and other reimbursements, when applicable.</li>
                                        <li>Pay listed above includes taxable wages and tax-free expense reimbursements.</li>
                                    </ul>
                                    <p className="text-xs italic text-gray-600 py-2">
                                        For all employees and employee applicants, Aya is an Equal Employment Opportunity ("EEO") Employer, including Disability/Vets, and welcomes all to apply. Please click <a href="#" className="text-black font-semibold">here</a> for our EEO policy.
                                    </p>
                                </div>
                            </div>

                        </div>


                        <div className="lg:w-[40%] p-4 rounded-lg mt-4 lg:mt-0" style={{
                            boxShadow: "rgba(0, 0, 0, 0.15) 0px 5px 15px 0px",
                        }}>
                            <h1 className="font-bold">Other Jobs You May Like</h1>
                            <div className="flex flex-col gap-y-6 mt-4">
                                <div>
                                    <h2 className="font-semibold">
                                        NEW HAVEN, CONNECTICUT
                                    </h2>
                                    <div className="text-gray-600 text-sm">
                                        <div className="flex items-center gap-x-1">
                                            <BiPlusMedical />
                                            <span>
                                                Yale - New Haven Hospital
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <CiStethoscope />
                                            <span>
                                                ICU
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            < AiOutlineClockCircle />
                                            <span>
                                                4 X 12
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <span className="text-lg font-semibold">
                                                $
                                            </span>
                                            <span className="block">
                                                $3476.59 to $3640.39 weekly
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <FiUsers />
                                            <span className="block">
                                                1 Opening
                                            </span>
                                        </div>
                                    </div>
                                </div>    <div>
                                    <h2 className="font-semibold">
                                        NEW HAVEN, CONNECTICUT
                                    </h2>
                                    <div className="text-gray-600 text-sm">
                                        <div className="flex items-center gap-x-1">
                                            <BiPlusMedical />
                                            <span>
                                                Yale - New Haven Hospital
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <CiStethoscope />
                                            <span>
                                                ICU
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            < AiOutlineClockCircle />
                                            <span>
                                                4 X 12
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <span className="text-lg font-semibold">
                                                $
                                            </span>
                                            <span className="block">
                                                $3476.59 to $3640.39 weekly
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <FiUsers />
                                            <span className="block">
                                                1 Opening
                                            </span>
                                        </div>
                                    </div>
                                </div>    <div>
                                    <h2 className="font-semibold">
                                        NEW HAVEN, CONNECTICUT
                                    </h2>
                                    <div className="text-gray-600 text-sm">
                                        <div className="flex items-center gap-x-1">
                                            <BiPlusMedical />
                                            <span>
                                                Yale - New Haven Hospital
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <CiStethoscope />
                                            <span>
                                                ICU
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            < AiOutlineClockCircle />
                                            <span>
                                                4 X 12
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <span className="text-lg font-semibold">
                                                $
                                            </span>
                                            <span className="block">
                                                $3476.59 to $3640.39 weekly
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <FiUsers />
                                            <span className="block">
                                                1 Opening
                                            </span>
                                        </div>
                                    </div>
                                </div>    <div>
                                    <h2 className="font-semibold">
                                        NEW HAVEN, CONNECTICUT
                                    </h2>
                                    <div className="text-gray-600 text-sm">
                                        <div className="flex items-center gap-x-1">
                                            <BiPlusMedical />
                                            <span>
                                                Yale - New Haven Hospital
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <CiStethoscope />
                                            <span>
                                                ICU
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            < AiOutlineClockCircle />
                                            <span>
                                                4 X 12
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <span className="text-lg font-semibold">
                                                $
                                            </span>
                                            <span className="block">
                                                $3476.59 to $3640.39 weekly
                                            </span>
                                        </div>
                                        <div className="flex items-center gap-x-1">
                                            <FiUsers />
                                            <span className="block">
                                                1 Opening
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="fixed bottom-4 right-6 bg-white rounded-lg py-2 px-4">
                    <details>
                        <summary className="text-gray-700">Questions? contact your Recruiter!</summary>
                        <div className="text-gray-500">
                            <h1>Samuel Vergara</h1>
                            <span className="block text-sm">
                                Sr. Surgical Services Recruiter
                            </span>
                            <div className="flex flex-col mt-2">
                                <div className="flex gap-x-1 items-center">
                                    <AiFillPhone />
                                    <a href="tel:(858) 666-6615">(858) 666-6615</a>
                                </div>
                                <div className="flex gap-x-1 items-center">
                                    <HiMail />
                                    <a href="mailto:Samuel.Vergara@ayahealthcare.com">Samuel.Vergara@ayahealthcare.com</a>
                                </div>
                            </div>
                        </div>
                    </details>
                </div>

                <div>
                    <Footer />
                </div>

            </div>
        </Navbar>
    )
}

export default JobDetailsPage